import {
  isLoggedIn,
  getCurrentUser as getCurrentUserId
} from '@src/redux/modules/auth'
import * as paths from 'utils/paths'

export default function redirectLoggedInUsersToNextServices (store) {
  return (nextState, replace) => {
    const state = store.getState()

    const loggedIn = isLoggedIn(state)

    if (loggedIn) {
      const userId = getCurrentUserId(state)
      const next = paths.userNextServices(userId)
      replace(next)
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/redirectLoggedInUsersToNextServices.js